"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReduxI18n = require("react-redux-i18n");

var _reactDropzone = require("react-dropzone");

var _Icon = _interopRequireDefault(require("../Icon"));

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function UploadDropzone(props) {
  var _useDropzone = (0, _reactDropzone.useDropzone)({
    accept: props.extensions,
    maxSize: props.maxSize,
    minSize: props.minSize,
    multiple: false,
    onDrop: props.onDrop
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({}, getRootProps()), {}, {
      className: "mt-4 background-gradient-light",
      style: {
        borderRadius: '4px',
        border: 'dashed 2px',
        borderColor: '#d8d8d8'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({}, getInputProps())), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "p-4 clickable background-image-transition",
        style: {
          display: 'flex',
          flexDirection: 'column',
          boxSizing: 'border-box',
          alignItems: 'center',
          justifyContent: 'center',
          height: 180,
          backgroundColor: isDragActive ? 'rgba(255,255,255,0)' : 'rgba(255,255,255,1)',
          transition: 'background-color .2s ease-in-out, height .5s ease-in'
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex-container column center",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
              icon: "upload",
              size: 80
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
              value: "document.dragDropHere"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "mt-4",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
              type: "button",
              className: "small secondary flex-container",
              color: "contrast",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
                icon: "folder-open"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
                value: "document.chooseOnComputer"
              })]
            })
          })]
        })
      })]
    })), props.errorFileMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "my-4",
      children: props.errorFileMessage
    })]
  });
}

UploadDropzone.propTypes = {
  file: _propTypes.default.object,
  extensions: _propTypes.default.string.isRequired,
  onDrop: _propTypes.default.func.isRequired,
  maxSize: _propTypes.default.number,
  minSize: _propTypes.default.number,
  errorFileMessage: _propTypes.default.node
};
UploadDropzone.defaultProps = {
  minSize: 0
};
var _default = UploadDropzone;
exports.default = _default;
//# sourceMappingURL=UploadDropzone.js.map